//base64 encoding
export let fileToDataURL = (file,filename) =>{
    return new Promise((resolve, reject) => {
        try {
            //check if is an instance of file;
            if(file instanceof File){
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => {
                    throw error;
                };
            }else{
                throw new Error("DataURLs: argument 'file' is not an instance of 'File' ")
            }
        }catch(e){
            reject(e);
        }
    });
};
//base 64 decoding
export let dataURLtoFile = (dataurl, filename) => {
    return new Promise((resolve,reject) =>{
        try{
            let arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
            
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            let file = new File([u8arr], filename, {type:mime})
            resolve(file) 
        }catch(e){
            reject(e)
        }
    });
}
//creates an <a> element that downloads a specified dataURL
export let download = (uri,filename) => {
    let link = document.createElement("a");
    link.download = filename;
    link.href = encodeURI(uri); //must always be encoded... check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}


// WEBPACK FOOTER //
// ./src/DataURIs.js